import React from 'react';
import { Grid } from '@mui/material';
import { noTopGutterSx } from 'src/UIKit';
import { ContactDateField } from '../../fields';
import { FieldWithProperties } from '../../FieldWithProperties';
import { SectionProps } from '../../../registry/sectionRegistry';

/**
 * Contact-date-type field + its Visible/Required/Label properties.
 * Bound to config.contact_date_type. Used by annual.
 */
export const ContactDateSection: React.FC<SectionProps> = ({
  config,
  onConfigUpdate,
  options,
  selected,
  onSelect,
}) => {
  const contactDate = config.contact_date_type;

  const update = (patch: Partial<typeof contactDate>) =>
    onConfigUpdate({
      contact_date_type: {
        ...contactDate,
        value: contactDate?.value ?? null,
        visible: contactDate?.visible || false,
        required: contactDate?.required || false,
        ...patch,
      },
    });

  return (
    <Grid item xs={12} sx={noTopGutterSx}>
      <FieldWithProperties
        visible={contactDate?.visible ?? false}
        required={contactDate?.required ?? false}
        hideToggles
        label={contactDate?.label}
        onVisibleChange={visible => update({ visible })}
        onRequiredChange={required => update({ required })}
        onLabelChange={label => update({ label })}
        field={
          <ContactDateField
            value={contactDate?.value || null}
            onChange={value => update({ value })}
            visible={contactDate?.visible || false}
            required={contactDate?.required || false}
            isSelected={!!selected}
            onClick={() => onSelect?.()}
            label={contactDate?.label}
            options={options?.contactDateTypes || []}
          />
        }
      />
    </Grid>
  );
};
